/* libs/iot4bos/iot4bos-ui-backoffice/src/lib/components/dialogs/add-business-profile-dialog/add-business-profile-dialog.component.scss */
.slider-container {
  padding-top: 10px;
}
/*# sourceMappingURL=add-business-profile-dialog.component.css.map */
